<template lang="pug">
ValidationProvider(name="Land" :rules="rules" v-slot="{ errors, valid }")
  b-field(label="Land" label-position="on-border"
          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
    b-input(v-model="innerValue" disabled)
</template>

<script>
export default {
  props: {
    rules: {
      type: [Object, String],
      default: "required"
    },
    value: {
      type: null
    }
  },
  data() {
    return {
      innerValue: "Deutschland"
    };
  },
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
};
</script>